 
import React from 'react';

const Download: React.FC<object> = () => {

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_8816_152416)">
                <path
                    d="M1 11L1 12C1 13.6569 2.34315 15 4 15L12 15C13.6569 15 15 13.6569 15 12L15 11"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M5.17193 8.17182L8.00006 10.9999M8.00006 10.9999L10.8279 8.17092M8.00006 10.9999L8.00006 1"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 7.5L8 11M8 11L4.5 7.5M8 11V1"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_8816_152416">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Download;